export type Grade = 'A' | 'B' | 'C' | 'D' | 'F';

export interface GradeConfig {
  color: string;
  bg: string;
  text: string;
  label: string;
}

export const gradeConfig: Record<Grade, GradeConfig> = {
  A: {
    color: '#10b981',
    bg: 'bg-emerald-50 dark:bg-emerald-900/20',
    text: 'text-emerald-600 dark:text-emerald-400',
    label: 'Excellent',
  },
  B: {
    color: '#84cc16',
    bg: 'bg-lime-50 dark:bg-lime-900/20',
    text: 'text-lime-600 dark:text-lime-400',
    label: 'Good',
  },
  C: {
    color: '#eab308',
    bg: 'bg-yellow-50 dark:bg-yellow-900/20',
    text: 'text-yellow-600 dark:text-yellow-400',
    label: 'Fair',
  },
  D: {
    color: '#f97316',
    bg: 'bg-orange-50 dark:bg-orange-900/20',
    text: 'text-orange-600 dark:text-orange-400',
    label: 'Poor',
  },
  F: {
    color: '#ef4444',
    bg: 'bg-red-50 dark:bg-red-900/20',
    text: 'text-red-600 dark:text-red-400',
    label: 'Critical',
  },
};

/**
 * Get grade from score using thresholds aligned with backend scoring.py and
 * maintenance_scoring.py (SINGLE SOURCE OF TRUTH):
 *   A → ≥85 → Excellent/Actively maintained
 *   B → ≥70 → Good/Well maintained
 *   C → ≥55 → Fair/Needs attention
 *   D → ≥40 → Poor/At risk
 *   F → <40 → Critical/Abandoned
 */
export const getGradeFromScore = (score: number): Grade => {
  if (score >= 85) return 'A';
  if (score >= 70) return 'B';
  if (score >= 55) return 'C';
  if (score >= 40) return 'D';
  return 'F';
};
